export default __webpack_public_path__ + "static/media/graphic-16.947987ec.png";